// test1254
(1254 && 0);
